import { translate } from '@teamleader/i18n';
import React from 'react';

import { BoxProps } from '../../../../Components/UI/Box';
import StatusLabel from '../../../../Components/UI/StatusLabel';
import { CUSTOMER_PORTAL_STATUS } from '../../../../Types/quotation';

interface QuotationStatusLabel extends BoxProps {
  status: CUSTOMER_PORTAL_STATUS;
}

const QuotationStatusLabel: React.FC<QuotationStatusLabel> = ({ status, ...rest }) => {
  switch (status) {
    case CUSTOMER_PORTAL_STATUS.SIGNED:
      return (
        <StatusLabel colored {...rest}>
          {translate('customerPortalStatus.signed')}
        </StatusLabel>
      );

    case CUSTOMER_PORTAL_STATUS.UPDATED:
      return <StatusLabel {...rest}>{translate('customerPortalStatus.updated')}</StatusLabel>;

    case CUSTOMER_PORTAL_STATUS.NEW:
      return <StatusLabel {...rest}>{translate('customerPortalStatus.new')}</StatusLabel>;

    default:
      return null;
  }
};

export default QuotationStatusLabel;
